import { ReactElement } from 'react';

import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import {
   HealthcareProviderLocation,
   useGetHealthcareProviderLocations,
} from '~libs.shared.healthcare-provider-location';

import { translationKeys } from '../../../translations';

type LocationFieldChildrenRenderProps = {
   locations: HealthcareProviderLocation[];
};

type LocationLoaderProps = {
   children: (renderProps: LocationFieldChildrenRenderProps) => ReactElement;
};

export const LocationFieldLoader = (props: LocationLoaderProps): ReactElement => {
   const { locations, loading: locationsLoading, error: locationsFetchError } = useGetHealthcareProviderLocations();

   if (locationsLoading) {
      return <LoaderSpinner />;
   }

   if (locationsFetchError) {
      return (
         <Message
            testId={'failedToFetchData'}
            label={translationKeys.fetchError}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({ locations: locations ?? [] });
};
